import React, {useEffect, useState} from 'react';
import {Button} from 'primereact/button';
import {UuserService} from "../../service/UuserService";
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GeneralUtils from "../../utils/GeneralUtils";
import {InputText} from "primereact/inputtext";
import {FileUpload} from "primereact/fileupload";
import BreadcrumbThree from "../../components/breadcrumb/breadcrumb-3";
import {Editor} from "primereact/editor";
import PasswordChange from "../../components/PasswordChange";
import {Toolbar} from "primereact/toolbar";
import {Dialog} from "primereact/dialog";
import FileUploader from "../../components/fileUploader/FileUploader";
import ProfilePhotoChange from "../../components/ProfilePhotoChange";


const defaultUser = {
    title: '',
    displayName: '',
    email: '',
    description: '',
    jobTitle: '',
    urlFacebook: '',
    urlLinkedin: '',
    urlPersonalWebsite: '',
    urlTwitter: '',
    urlYoutube: ''
}
const Profile = () => {
    const [data, setData] = useState(defaultUser);
    const [displayDialogPhoto, setDisplayDialogPhoto] = useState(false);
    const [displayDialogPass, setDisplayDialogPass] = useState(false);
    const service = new UuserService();


    useEffect(() => {
        // service.checkPage();
        refresh();
    }, []);

    const refresh = () => {
        service.findById(GeneralUtils.getUserId()).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response)) {
                if (response) {
                    // let user = GeneralUtils.getUser();
                    // user.image200h = response.image200h;
                    // user.image50x50 = response.image50x50;
                    // localStorage.setItem("uUser",  JSON.stringify(user));
                    setData(response);
                }
            }
        });
    }


    const handleChange = (e) => {
        const value = e.target.value;
        setData({...data, [e.target.name]: value});
    }

    const handleChangeEditor = (e) => {
        const value = e.htmlValue;
        setData((prevData) => ({...prevData, description: value}));
    }

    const submitChange = () => {
        if (GeneralUtils.isNullOrEmpty(data.title) || GeneralUtils.isNullOrEmpty(data.email)) {
            return toast.warn('Lütfen isim ve email alanlarını doldurun.');
        }
        service.update(data);
    };




    const header = (
        <span className="ql-formats">
                <button className="ql-bold" aria-label="Bold"></button>
                <button className="ql-italic" aria-label="Italic"></button>
                <button className="ql-underline" aria-label="Underline"></button>
                <button className="ql-strike" aria-label="Strike"></button>
            </span>
    );

    const userPhoto = (
        <div className="flex flex-column justify-content-around align-items-center">
            <div className="team-details-thumb">
                <div className="thumbnail">
                    {(data.image200h && !displayDialogPhoto) ?
                        <img className="instructor-image" src={data.image200h} alt="instructor-image"  width="150"
                            // onError={(e) => e.target.src = "/icons/user-empty2.png"}
                        /> :
                        <img className="instructor-image" src="/archive/icons/user-empty2.png" alt="instructor-image" width="150"/>
                    }
                </div>
            </div>
            {/*<FileUpload mode="basic" name="demo[]" url="/api/upload" accept="image/*" maxFileSize={1000000}*/}
            {/*            onUpload={onUpload} auto chooseLabel="Fotoğrafı değiştir"/>*/}
            {/*<small><p>Fotoğrafı değiştirdikten sonra kaydetmeyi unutmayınız.</p></small>*/}
        </div>
    );



    return (
        <>
            <BreadcrumbThree title={userPhoto}/>
            <div className="flex flex-row justify-content-around m-4">
                <div className="flex flex-column gap-3 mr-8 ml-5 w-5">
                    <Toolbar end={
                        <div className="flex justify-content-end gap-2">
                            <Button className="p-inputtext-sm" label="Fotoğraf" icon="pi pi-image"
                                    onClick={() => setDisplayDialogPhoto(true)}/>
                            <Button className="p-inputtext-sm" label="Şifre" icon="pi pi-key"
                                    onClick={() => setDisplayDialogPass(true)}/>
                        </div>
                    } className="mt-2 mb-2"/>
                    {/*<PhotoChange/>*/}


                    <label>Temel Bilgiler</label>
                    <InputText name="title" value={data.title} onChange={handleChange} placeholder="Ad Soyad"
                               className="inputtext p-inputtext-sm"/>
                    <InputText name="email" value={data.email} onChange={handleChange} placeholder="Email" disabled={true}
                           className="inputtext p-inputtext-sm"/>
                <div className="flex flex-column">
                    <InputText name="jobTitle" value={data.jobTitle} onChange={handleChange} placeholder="Başlık"
                               className="inputtext p-inputtext-sm"/>
                    <small name="jobTitle-help">
                        "Eğitmen" veya "Mimar" gibi profesyonel bir başlık ekleyin.
                    </small>
                </div>
                <div className="flex flex-column">
                    <Editor name="description"
                            value={data.description}
                            onTextChange={handleChangeEditor}
                            headerTemplate={header}
                            style={{height: '250px'}}/>
                    <small id="description-help">
                        Kendi hakkınızda bir açıklama ekleyin.
                    </small>
                </div>

                <label>Bağlantılar</label>
                <InputText name="urlFacebook" value={data.urlFacebook} onChange={handleChange}
                           placeholder={"http://facebook.com/..."} className="inputtext p-inputtext-sm"/>
                <InputText name="urlLinkedin" value={data.urlLinkedin} onChange={handleChange}
                           placeholder={"http://linkedin.com/..."} className="inputtext p-inputtext-sm"/>
                <InputText name="urlTwitter" value={data.urlTwitter} onChange={handleChange}
                           placeholder={"http://twitter.com/..."} className="inputtext p-inputtext-sm"/>
                <InputText name="urlYoutube" value={data.urlYoutube} onChange={handleChange}
                           placeholder={"http://youtube.com/..."} className="inputtext p-inputtext-sm"/>
                <InputText name="urlPersonalWebsite" value={data.urlPersonalWebsite} onChange={handleChange}
                           placeholder={"Web sitesi"} className="inputtext p-inputtext-sm"/>
                <Button label="Kaydet" onClick={submitChange}/>
            </div>
            </div>
            <Dialog header="Fotoğraf Değiştirme" visible={displayDialogPhoto} style={{width: '50vw'}} onHide={() => setDisplayDialogPhoto(false)}>
                <ProfilePhotoChange src={data.image200h} closeDialog={() => {
                    setDisplayDialogPhoto(false);
                    refresh();
                }}/>
            </Dialog>
            <Dialog header="Şifre Değiştirme" visible={displayDialogPass} style={{width: '25vw'}} onHide={() => setDisplayDialogPass(false)}>
                <PasswordChange closeDialog={() => setDisplayDialogPass(false)}/>
            </Dialog>
        </>
    )
}

export default Profile;